import { render, staticRenderFns } from "./LevelWin.vue?vue&type=template&id=f31832a2&scoped=true&"
import script from "./LevelWin.vue?vue&type=script&lang=js&"
export * from "./LevelWin.vue?vue&type=script&lang=js&"
import style0 from "./LevelWin.vue?vue&type=style&index=0&id=f31832a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31832a2",
  null
  
)

component.options.__file = "LevelWin.vue"
export default component.exports